"use strict";
exports.__esModule = true;
exports.CREDIT_BUILDER_CONGRATS_CONTENT = void 0;
var AUTOPAY = {
    BODY: 'Each month, Flex will automatically collect your rent and transfer it to your property, starting with your',
    BODY_TWO: 'bill. Check your email for more info.',
    DOWNLOAD: 'Download the app to keep up-to-date with your Flex status.'
};
var AUTOPAY_OFF = {
    BODY: 'When rent is due, just use the app to kick off your rent payment. Check your email for more info.',
    DOWNLOAD: 'Download the Flex app to get started.'
};
var HIGHLIGHT = {
    TITLE: 'Remember...',
    BODY_1_BOLD: 'Flex pays rent to your property on your behalf.',
    BODY_1: 'If you have autopay set up in your rent portal, turn it off.',
    BODY_2_BOLD: 'Flex will charge your card for your full rent amount. ',
    BODY_2: 'Ensure you have the funds available when rent is due.'
};
exports.CREDIT_BUILDER_CONGRATS_CONTENT = {
    HEADER: 'Congrats!',
    CTA: 'Finish',
    BODY_1: 'You’re ready to boost your credit!\nFlex will start with your',
    BODY_2: 'bill.',
    HIGHLIGHT: HIGHLIGHT,
    AUTOPAY: AUTOPAY,
    AUTOPAY_OFF: AUTOPAY_OFF
};
